// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fx {
    display: flex;
}

.aln-center {
    display: flex;
    align-items: center;
}

.aln-start {
    display: flex;
    align-items: flex-start;
}

.aln-end {
    display: flex;
    align-items: flex-end;
}

.jst-center {
    display: flex;
    justify-content: center;
}

.jst-sa {
    display: flex;
    justify-content: space-around;
}

.jst-start {
    display: flex;
    justify-content: flex-start;
}

.jst-end {
    display: flex;
    justify-content: flex-end;
}

.jst-sb {
    display: flex;
    justify-content: space-between;
}

.fx-center {
    display: flex;
    align-items: center;
    justify-content: center;
}

.fx-col {
    display: flex;
    flex-direction: column;
}

.fx-nowrap {
    display: flex;
    flex-wrap: nowrap;
}

.display-none {
    display: none;
}
`, "",{"version":3,"sources":["webpack://./src/utils/styles/styles.css"],"names":[],"mappings":"AAAA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".fx {\r\n    display: flex;\r\n}\r\n\r\n.aln-center {\r\n    display: flex;\r\n    align-items: center;\r\n}\r\n\r\n.aln-start {\r\n    display: flex;\r\n    align-items: flex-start;\r\n}\r\n\r\n.aln-end {\r\n    display: flex;\r\n    align-items: flex-end;\r\n}\r\n\r\n.jst-center {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.jst-sa {\r\n    display: flex;\r\n    justify-content: space-around;\r\n}\r\n\r\n.jst-start {\r\n    display: flex;\r\n    justify-content: flex-start;\r\n}\r\n\r\n.jst-end {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n}\r\n\r\n.jst-sb {\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.fx-center {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n}\r\n\r\n.fx-col {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.fx-nowrap {\r\n    display: flex;\r\n    flex-wrap: nowrap;\r\n}\r\n\r\n.display-none {\r\n    display: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
